import pagination from "../../utils/pagination";
import {
    OVERVIEW_BATCH_DELETE_REQUEST,
    OVERVIEW_BATCH_DELETE_SUCCESS,
    OVERVIEW_BATCH_DELETE_FAILURE,
    OVERVIEW_FETCH_MANY_REQUEST,
    OVERVIEW_FETCH_MANY_SUCCESS,
    OVERVIEW_FETCH_MANY_FAILURE,
    OVERVIEW_FETCH_REQUEST,
    OVERVIEW_FETCH_SUCCESS,
    OVERVIEW_FETCH_FAILURE,
    OVERVIEW_SAVE_REQUEST,
    OVERVIEW_SAVE_SUCCESS,
    OVERVIEW_SAVE_FAILURE,
    EMPTY_OVERVIEW,
    CLEAR_ERRORS
} from "./types";

export default {
    [OVERVIEW_BATCH_DELETE_REQUEST](state) {
        state.deleting = true;
    },
    [OVERVIEW_BATCH_DELETE_SUCCESS](state) {
        state.deleting = false;
    },
    [OVERVIEW_BATCH_DELETE_FAILURE](state) {
        state.deleting = false;
    },
    [OVERVIEW_FETCH_MANY_REQUEST](state) {
        state.data = [];
        state.loading = true;
    },
    [OVERVIEW_FETCH_MANY_SUCCESS](state, { data }) {
        state.data = data.data;
        state.page = pagination(data);
        state.loading = false;
    },
    [OVERVIEW_FETCH_MANY_FAILURE](state, { validationErrors }) {
        state.validationErrors = validationErrors || {};
        state.loading = false;
    },
    [OVERVIEW_FETCH_REQUEST](state) {
        state.single = {};
        state.loading = true;
    },
    [OVERVIEW_FETCH_SUCCESS](state, { data }) {
        state.single = data;
        state.loading = false;
    },
    [OVERVIEW_FETCH_FAILURE](state) {
        state.loading = false;
    },
    [OVERVIEW_SAVE_REQUEST](state) {
        state.data = [];
        state.saving = true;
    },
    [OVERVIEW_SAVE_SUCCESS](state) {
        state.saving = false;
    },
    [OVERVIEW_SAVE_FAILURE](state, { validationErrors }) {
        state.validationErrors = validationErrors || {};
        state.saving = false;
    },
    [EMPTY_OVERVIEW](state) {
        state.data = [];
        state.loading = false;
        state.saving = false;
    },
    [CLEAR_ERRORS](state) {
        state.validationErrors = [];
        state.loading = false;
        state.saving = false;
    }
};
